import React from 'react';
import { motion } from 'framer-motion';
export function Origin() {
  return <section className="py-16 bg-white" data-id="element-136">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl" data-id="element-137">
        {/* Todo comenzó en una cocina común */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16" data-id="element-138">
          <h2 className="text-3xl font-bold text-brown-900 text-center mb-6" data-id="element-139">
            Todo comenzó en una cocina común
          </h2>

          <p className="text-lg text-brown-800/80 mb-6 max-w-2xl mx-auto text-center" data-id="element-140">
            Sin dinero extra, sin experiencia en negocios y con muchas cuentas
            por pagar. Un día, después de llevar budines caseros a una reunión
            familiar, ocurrió algo inesperado. Todos preguntaban:
          </p>

          <div className="bg-cream-50 p-5 rounded-2xl border border-cream-200 mb-6 font-medium text-brown-900 italic text-center space-y-1 max-w-md mx-auto" data-id="element-141">
            <p data-id="element-142">
              “¿Quién hizo esto?” · “¿Vendés?” · “Te compraría uno ahora mismo.”
            </p>
          </div>

          <p className="text-lg text-brown-800/80 text-center max-w-2xl mx-auto" data-id="element-143">
            Lo que empezó como una simple receta se convirtió en pedidos,
            clientes frecuentes y{' '}
            <span className="font-bold text-burgundy-600" data-id="element-144">
              después en ingresos reales.
            </span>
          </p>

          <blockquote className="border-l-4 border-gold-500 pl-5 py-2 mt-8 bg-cream-50 rounded-r-lg font-medium text-brown-900 max-w-2xl mx-auto" data-id="element-145">
            La gente busca productos auténticos. Productos hechos con amor.
            Productos que les recuerden hogar.
          </blockquote>
        </motion.div>

        {/* Pero yo no tengo experiencia... */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-cream-50 rounded-3xl p-8 border border-cream-200 max-w-2xl mx-auto" data-id="element-146">
          <h2 className="text-2xl sm:text-3xl font-bold text-brown-900 mb-4" data-id="element-147">
            “Pero yo no tengo experiencia…”
          </h2>
          <p className="font-bold text-xl text-burgundy-600 mb-3" data-id="element-148">Perfecto.</p>
          <p className="text-brown-800/80 mb-3" data-id="element-149">
            Esta guía fue creada precisamente para principiantes. No necesitás
            conocimientos previos ni saber de negocios.
          </p>
          <p className="font-handwriting text-3xl text-burgundy-600" data-id="element-150">
            Solo seguí el método, paso a paso.
          </p>
        </motion.div>
      </div>
    </section>;
}